module.exports = __webpack_public_path__ + "img/16.852af916.webp";